import { createAsyncActions } from '~/utils/store';

export const SHOW = '@@DRAWER_PROSPECTIONS/SHOW';
export const CLOSE = '@@DRAWER_PROSPECTIONS/CLOSE';

export const CREATE = createAsyncActions('@@DRAWER_PROSPECTIONS/CREATE');
export const BATCH = createAsyncActions('@@DRAWER_PROSPECTIONS/BATCH');
export const SAVE = createAsyncActions('@@DRAWER_PROSPECTIONS/SAVE');
export const DELETE = createAsyncActions('@@DRAWER_PROSPECTIONS/DELETE');

export const FETCHQTDD = createAsyncActions('@@PROSPECTIONS/FETCHQTDD');
export const MOVE = createAsyncActions('@@PROSPECTIONS/MOVE');
export const LOAD = createAsyncActions('@@PROSPECTIONS/LOAD');
export const LOAD_MORE_LEADS = createAsyncActions('@@PROSPECTIONS/LOAD_MORE_LEADS');

export const show = (data = null) => ({
    type: SHOW,
    payload: {
        data
    }
});

export const close = () => ({
    type: CLOSE,
    payload: {}
});

export const create = (data) => ({
    type: CREATE.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2',
            data,
            showLoading: false
        }
      }
});

export const batch = (data) => ({
    type: BATCH.INIT,
    payload: {
        request:{
            method: 'post',
            url:'/leads_v2/batch',
            data,
            showLoading: false
        }
      }
});

export const update = (id, data) => ({
    type: SAVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads_v2/${id}`,
            data,
            showLoading: false
        }
    }
});

export const remove = (lead) => ({
    type: DELETE.INIT,
    payload: {
        request:{
            method: 'delete',
            url:`/leads_v2/${lead.id}`
        },
        lead
    }
});

export const loadLeads = ({ ...params }) => ({
    type: LOAD.INIT,
    payload: {
        request: {
            method: "GET",
            url: "/leads_v2?entity_type=prospecting",
            ...params
        }
    }
});

export const loadMoreLeads = ({ columnId, currentCount, moreCount }) => ({
    type: LOAD_MORE_LEADS.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads_v2/more?stage=${columnId}&current_count=${currentCount}&more_count=${moreCount}&entity_type=prospecting`,
            columnId
        },
    },
})

export const fetchQtddByMonth = ({ date }) => ({
    type: FETCHQTDD.INIT,
    payload: {
        request:{
            method: 'get',
            url:`/leads_v2/qtdd/${date}?entity_type=prospecting`
        }
    }
});

export const move = (props) => ({
    type: MOVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads_v2/${props[4]}/move?entity_type=prospecting`,
            data: {to: props[3].droppableId}
        },
    },
    props: props
});